<template>
    <div>
        <v-btn type="button" block text :color="color" @click="dialog = !dialog" style="text-transform: lowercase">
            ¿Ha olvidado su contraseña?
        </v-btn>

        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card class="pa-5">
                <v-card-title>
                    Restablecer contraseña
                </v-card-title>
                <v-form v-model="form" ref="form" v-on:submit.prevent="email_form">
                    <v-card-subtitle>
                        <p class="pb-0 mb-0">
                            Ingrese el correo electrónico relacionado a su cuenta, recibirá un enlace para restablecer su contraseña. El enlace
                            solo estará disponible durante los próximos 30 minutos.
                        </p>
                    </v-card-subtitle>
                    <v-card-text class="px-0">
                        <v-container fluid>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="email"
                                        filled
                                        :color="color"
                                        append-icon="mdi-at"
                                        label="Correo electrónico"
                                        clearable
                                        :rules="[rules.required, rules.email]"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn type="submit" :block="loading" outlined large :color="color" :loading="loading">Solicitar enlace</v-btn>
                        <v-btn type="button" v-show="!loading" :color="color" @click="dialog = false" text>Cancelar</v-btn>
                    </v-card-actions>
                 </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>

import iziToast from 'izitoast'

export default {
    data: () => ({
        //urls
        email_url:"/password/email",

        //models
        dialog:false,
        email:"",
        loading:false,
        form:false,

        //props
        color: "#008DD4",

        //rules
        rules:{
            required: v => !!v || 'El campo es requerido',
            email: v => /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/.test(v) || 'El Correo electrónico ingresado no es válido'
        }
    }),

    methods:{
        email_form:function(){
            this.$refs.form.validate()

            if(this.form){
                this.loading = true

                let data = new Object()
                data.email = this.email

                axios.post(this.email_url, data).then(response => {

                    this.loading = false
                    this.dialog = false
                    this.$refs.form.reset()

                    iziToast.success({
                        title:"Correcto",
                        position:'topRight',
                        message: 'Se ha enviado un enlace de restauración a tu correo electrónico.'
                    })

                }).catch(error => {

                    this.loading = false
                    this.dialog = false
                    this.$refs.form.reset()

                    if(error.response.data.errors){
                        for(let prop in error.response.data.errors){
                            for(let message of error.response.data.errors[prop]){
                                iziToast.error({
                                    title:"Error",
                                    position:'topRight',
                                    message: message
                                })
                            }
                        }
                    }

                    if(error.response.data.existent){
                        iziToast.error({
                            title:"Error",
                            position:'topRight',
                            message: 'Debe esperar al menos 30 minutos para poder solicitar otro enlace de restauración.'
                        })
                    }

                })
            }
        }
    }
}
</script>
